import React, { FC } from 'react';
import { IconProps } from './IconInterface';

export const ReportsIcon: FC<IconProps> = ({ fill, width, height }: IconProps) => (
  <svg id="Layer_1" viewBox="0 0 32 32" width={width} height={height} fill={fill}>
    <path
      d="M11.8,12a8,8,0,1,0,8,8A8,8,0,0,0,11.8,12Zm-6,8a6,6,0,0,1,5-5.9V20c0,.5-.2.1,4,5.2A6,6,0,0,1,5.8,20Zm10.6,3.9-3.6-4.3V14.1A6,6,0,0,1,16.4,23.9Z"
      fill="current"
    />
    <path d="M22.8,15h4a1,1,0,0,0,0-2h-4a.94.94,0,0,0-1,1A1,1,0,0,0,22.8,15Z" fill="current" />
    <path d="M26.8,17h-4a1,1,0,1,0,0,2h4a1,1,0,0,0,0-2Z" fill="current" />
    <path d="M26.8,21h-4a1,1,0,1,0,0,2h4a1,1,0,0,0,0-2Z" fill="current" />
    <path d="M26.8,25h-4a1,1,0,1,0,0,2h4a1,1,0,0,0,0-2Z" fill="current" />
    <path
      d="M28.8,8H28L18,3a1,1,0,1,0-.8,1.8L23.6,8H8.2l6.4-3.2A1,1,0,1,0,13.8,3L3.8,8H3a3,3,0,0,0-3,3V29a3,3,0,0,0,3,3H6a1,1,0,0,0,0-2H3a.94.94,0,0,1-1-1V11a.94.94,0,0,1,1-1H29a.94.94,0,0,1,1,1V29a.94.94,0,0,1-1,1H10a1,1,0,0,0,0,2H29a3,3,0,0,0,3-3V11A3.25,3.25,0,0,0,28.8,8Z"
      fill="current"
    />
    <path
      d="M15.8,6a3,3,0,0,1-3-3,3,3,0,0,1,6,0A3,3,0,0,1,15.8,6Zm0-4a.94.94,0,0,0-1,1,1,1,0,0,0,2,0A.94.94,0,0,0,15.8,2Z"
      fill="current"
    />
  </svg>
);
